<template>
	<div>
		<div v-for="(item,index) in qusetionlist">
			<div :class="(item.topicType == 1||item.topicType == 3)?'single':''" v-show="questionindex == index">
				<div class="questionTitle">
					{{index+1}}、
					<span v-if="item.topicType == 4">
									{{item.question | spliceQuestion}}
								</span>
					<span v-if="item.topicType != 4">
									{{item.question}}
								</span>
					<span class="maincolor">
									（<span v-if="item.topicType == 1">单选题</span>
					<span v-if="item.topicType == 2">多选题</span>
					<span v-if="item.topicType == 3">判断题</span>
					<span v-if="item.topicType == 4">填空题</span>
					<span v-if="item.topicType == 5">简答题</span>）
					</span>
					<div v-if="item.isFile == '1'" class="filebox" style="margin: 20px 0 0 0;">
						<div class="fileboxname">图片/视频：</div>
						<div>
							<span :key='file.id' v-for="(file,fileindex) in item.files">
											<video style="width: 150px; height: 150px" :src="baseurl + file.url" v-if="file.url.indexOf('.mp4')>-1" controls="controls" muted="muted"></video><el-image fit="fill" style="width: 150px; height: 150px" :src="baseurl + file.url" :preview-src-list="[baseurl + file.url]" v-else>
											</el-image>
										</span>
						</div>
					</div>
				</div>
				<div v-if="item.topicType == 1">
					<div class="questionAnswers" @click="singleAnswer(it,i,index)" v-for="(it,i) in item.answerlist">
						<div class="questionLabel">
							<div :class="item.choose.indexOf(it.label) != -1?'outCircle outCircleSelcet':'outCircle'">
								<div class="inCircle"></div>
							</div>
						</div>
						<span>
										{{it.label}}、
										<span v-if="it.type == '1'">{{it.value}}</span>
						<span v-if="it.type == '2'" @click.stop>
											<br />
											<video style="width: 150px; height: 150px" :src="baseurl+it.value" v-if="it.value.indexOf('.mp4')>-1" controls="controls" muted="muted"></video><el-image :key='i' fit="fill" style="width: 100px; max-height: 100px" :src="baseurl+it.value" :preview-src-list="[baseurl+it.value]" v-else></el-image>
										</span>
						</span>
					</div>
				</div>
				<div v-if="item.topicType == 2">
					<!--Multiple-->
					<div class="questionAnswers" @click="multipleAnswer(it,i,index)" v-for="(it,i) in item.answerlist">
						<div class="questionLabel">
							<div :class="item.choose.indexOf(it.label) != -1?'outCircle outCircleSelcet':'outCircle'">
								<div class="inCircle"></div>
							</div>
						</div>
						<span>
										{{it.label}}、
										<span v-if="it.type == '1'">{{it.value}}</span>
						<span v-if="it.type == '2'" @click.stop>
											<br />
											<video style="width: 150px; height: 150px" :src="baseurl+it.value" v-if="it.value.indexOf('.mp4')>-1" controls="controls" muted="muted"></video><el-image :key='i' fit="fill" style="width: 100px; max-height: 100px" :src="baseurl+it.value" :preview-src-list="[baseurl+it.value]" v-else></el-image>
										</span>
						</span>
					</div>
				</div>
				<div v-if="item.topicType == 3">
					<div class="questionAnswers" @click="singleAnswer(it,i,index)" v-for="(it,i) in item.answerlist">
						<div class="questionLabel">
							<div :class="item.choose.indexOf(it.label) != -1?'outCircle outCircleSelcet':'outCircle'">
								<div class="inCircle"></div>
							</div>
						</div>
						<span>
										{{it.label}}、
										<span v-if="it.type == '1'">{{it.value}}</span>
						<span v-if="it.type == '2'" @click.stop>
											<br />
											<video style="width: 150px; height: 150px" :src="baseurl+it.value" v-if="it.value.indexOf('.mp4')>-1" controls="controls" muted="muted"></video><el-image :key='i' fit="fill" style="width: 100px; max-height: 100px" :src="baseurl+it.value" :preview-src-list="[baseurl+it.value]" v-else></el-image>
										</span>
						</span>
					</div>
				</div>
				<div v-if="item.topicType == 4">
					<el-input placeholder="请输入答案" v-model="item.userAnswer" @input="blanksAnswer(index)">
					</el-input>
				</div>
				<div v-if="item.topicType == 5">
					<el-input type="textarea" resize="none" :rows="6" placeholder="请输入内容" v-model="item.userAnswer" @input="blanksAnswer(index)">
					</el-input>
				</div>
			</div>
		</div>
		<div class="videotopic">
			<el-button type='primary' @click='addAnswer' v-show='!qusetionlist[questionindex].overdata'>提交</el-button>
			<el-button type='success' @click='closeAsk' v-show='qusetionlist[questionindex].overdata && qusetionlist[questionindex].userAnswer == qusetionlist[questionindex].answer'>关闭</el-button>
			<el-button type='danger' @click='reAnswer' v-show='qusetionlist[questionindex].overdata && qusetionlist[questionindex].userAnswer != qusetionlist[questionindex].answer'>再看一次</el-button>
			<el-button type='primary' @click='skipAsk' v-show='qusetionlist[questionindex].overdata && qusetionlist[questionindex].userAnswer != qusetionlist[questionindex].answer && qusetionlist[questionindex].isSkip == "1"'>跳过此题</el-button>
		</div>
	</div>
</template>

<script>
	import { addAskTopicAnswer } from "@/api/course.js"
	export default {
		name: 'task',
		props: {
			qusetionlist: Array,
			questionindex: Number,
		},
		data() {
			return {
				
			}
		},
		created() {
			
		},
		methods: {
			skipAsk() {
				this.$emit('skipAsk')
			},
			closeAsk() {
				this.$emit('closeAsk')
			},
			reAnswer() {
				var qusetionlist = this.qusetionlist;
				var index = this.questionindex;
				qusetionlist[index].overdata = false;
				qusetionlist[index].userAnswer = '';
				qusetionlist[index].over = false;
				qusetionlist[index].choose = [];
				this.$set(this.qusetionlist, index, qusetionlist[index]);
				this.$emit('relookAsk')
			},
			addAnswer() {
				var qusetionlist = this.qusetionlist;
				var index = this.questionindex;
				if(qusetionlist[index].over == true) {
					qusetionlist[index].userAnswer = qusetionlist[index].choose.join('');
					qusetionlist[index].overdata = true;
					this.$set(this.qusetionlist, index, qusetionlist[index]);
					this.uploadQuestion(qusetionlist[index]);
				} else {
					this.$message({
						type: 'error',
						message: '请先作答！'
					})
				}
			},
			uploadQuestion(item) {
				var data = {
					askTopicId: item.id,
					userAnswer: item.userAnswer,
				}
				addAskTopicAnswer(data).then(res => {
					if(item.userAnswer == item.answer) {
						this.$message({
							type: 'success',
							message: '答对了！'
						})
					} else {
						this.$message({
							type: 'error',
							message: '答错了！'
						})
					}
				})
			},
			singleAnswer(it, i, index) {
				var qusetionlist = this.qusetionlist;
				if(!qusetionlist[index].overdata) {
					var choose = [it.label];
					qusetionlist[index].choose = choose;
					qusetionlist[index].over = true;
					this.$set(this.qusetionlist, index, qusetionlist[index])
				}
			},
			multipleAnswer(it, i, index) {
				var qusetionlist = this.qusetionlist;
				if(!qusetionlist[index].overdata) {
					var choose = qusetionlist[index].choose;
					if(choose.indexOf(it.label) == -1) {
						choose.push(it.label)
					} else {
						var deleteIndex = choose.indexOf(it.label);
						choose.splice(deleteIndex, 1)
					}
					choose = choose.sort();
					qusetionlist[index].choose = choose;
					if(choose.length > 0) {
						qusetionlist[index].over = true;
					} else {
						qusetionlist[index].over = false;
					}
					this.$set(this.qusetionlist, index, qusetionlist[index])
				}
			},
			blanksAnswer(index) {
				var qusetionlist = this.qusetionlist;
				if(qusetionlist[index].userAnswer.length > 0) {
					qusetionlist[index].over = true;
				} else {
					qusetionlist[index].over = false;
				}
			},
		},
	}
</script>
<style type="text/css">
	.videotopic {
		margin: 15px 0 0 0;
		text-align: center;
	}
	
	.videotopic button {
		margin: 0 15px;
	}
</style>